import { success } from '@/utils/alert'
import { get, filter, find } from 'lodash'
import moment from 'moment'

export default {
  doSave () {
    const schedule = {
      ...this.time,
      professional_id: get(this.agenda, 'professional_id', null),
      agenda_id: get(this.agenda, 'agenda_id', null),
      price: get(this.agenda, 'price', null),
      speciality_id: get(this.filtersToSearch, 'specialities.id', null),
      // definindo valor null para quando for o valor para particular e não para convenios
      covenant_id: get(this.agenda, 'covenant_id', null)
    }
    schedule.patient = {...this.dataPatient}
    // para definir class como marcado
    this.$emit('scheduled', schedule.id)

    // preload enquanto processa agendamento
    this.schedulingProcessing = true

    this.$resource.save(schedule)
     .then(({data}) => {
       // desabilitando preload
       this.schedulingProcessing = false

       // precisar implemntar a funcionalidade envio de email na API
       success('Você receberá um email com a confirmação do agendamento desta consulta')
       this.show = true
       this.$emit('scheduled', schedule.id)
       this.$emit('close', true)
     })
     .catch(({data}) => {
     })
  },
  doClose () {
    this.$emit('close')
  },

  doVerifyBeforeClode () {
    if ((this.covenant !== 'undefined') || (this.covenant !== 'null')) {
      this.activeMsgSelectCovenant = true
    }
  },
  // Apos abrir o modal novamente para uma nova seleção
  doVerifyAfterClose (covenant) {
    if ((covenant === 0) && (covenant !== 'undefined')) {
      this.activeSchedules = false
      this.doesNotAttend = false
    }
    if (typeof covenant === 'undefined') {
    } else {
      if (covenant === null) {
        return
      }
      if ((covenant.length > 0) || (typeof covenant === 'undefined')) {
        this.verifyPrivate(covenant)
      }
    }
  },
  // Verificando se foi selecionado um convenio nao valido
  verifyPrivate (covenant) {
    if (covenant) {
      // efetuando split para gerar array
      const agendaCovenant = this.agenda.covenant.split(',')
      this.$http.get('v1/search/covenants/' + covenant)
        .then(({data}) => {
          this.covenantResource = data.name
          const selectedCovenant = this.covenantResource
          // const selectedCovenant = this.resourceCovenant

          const filterCovenantsPaitent = agendaCovenant.filter(function (c) {
            return c.trim() === selectedCovenant
          })

          // removido para novo neste com filtro pelo es6
          // const filterCovenantsPaitent = filter(agendaCovenant, (covenants) => {
          //   if (covenants) {
          //     return find(selectedCovenant, covenants)
          //   }
          // })

          // se convenio nao atendido desativa button
          if (filterCovenantsPaitent.length <= 0) {
            this.activeMsgSelectCovenant = false
            this.doesNotAttend = true
            this.activeSchedules = true
            this.alertCovenantNotExist = true
          }

          // se convenio é atendido ativa  button
          if (filterCovenantsPaitent.length >= 1) {
            this.doesNotAttend = false
            this.activeSchedules = false
            this.alertCovenantNotExist = false
          }
        })
    } else {
      this.activeSchedules = false
      this.doesNotAttend = false
      this.activeMsgSelectCovenant = false
    }
  },
  // Selecionando paciente para setar os convenios
  onSelectedPatient (patient) {
    this.patient.type = (patient) ? patient.type : null
    this.setCovenants(patient)

    // Verificando se existe alguns dos convenios do paciente que esteja no professional
    const filterCovenantsPaitenInProfessional = filter(this.agenda.covenants, (covenants) => {
      return find(patient.active_covenants, {id: covenants.id})
    })
    // senao existe convenio
    if (filterCovenantsPaitenInProfessional.length === 0) {
      this.alertCovenantNotExist = true
    }
    if (filterCovenantsPaitenInProfessional.length > 0) {
      this.alertCovenantNotExist = false
    }
  },
  setCovenants (patient) {
    this.covenant = {
      id: null,
      label: null
    }

    // verificando se existe convenios ativos se nao passa null
    if (!get(patient, 'active_covenants', null)) {
      this.covenants = []
      return
    }

    // Se tiver valor particular
    if (this.agenda.price === '0.00') {
      // adcionando Particular para todos os convenios
      this.covenants = [...patient.active_covenants]
    }

    // Se não tiver valor particular
    if (this.agenda.price !== '0.00') {
      // adcionando Particular para todos os convenios
      this.covenants = [{id: null, name: 'Particular'}, ...patient.active_covenants]
    }
  },
  doReserve () {
    this.reserving = true
    this.$http.post('/v1/patient/scheduling/bookings', {
      id: this.time.id
    }).then(({data}) => {
      this.countdown = moment().add(data.remaining, 'seconds')
      this.booking = true
      this.reserving = false
    }).catch(() => {
      this.$toast.warning('Este horário já esta reservado.')
      this.reserving = false
      this.doClose()
    })
  },
  doCancelReserve () {
    if (!this.booking) {
      return
    }
    this.$http.delete('/v1/patient/scheduling/bookings/' + this.time.id).then(() => {
    }).catch(() => {
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/form/resources/methods.js